export default __webpack_public_path__ + "static/media/gallery-wip-pommel_05.1b90f952.jpg";